export enum PinType {
  Enemy = "enemy",
  Ally = "ally",
  General = "general"
}

export interface PinData {
  id: string;
  mapId: string;
  xRatio: number;
  yRatio: number;
  tag: PinType;
  createdAt: number;
}

export interface MapConfig {
  name: string;
  src: string;
}

export interface Coordinates {
  xRatio: number;
  yRatio: number;
}

export type TapType = "single" | "double" | "long";

export interface LegendItem {
  color: string;
  label: string;
}
